import * as React from 'react';
import Select from 'react-select';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';

import * as _ from 'lodash';
import { Prompt } from 'react-router-dom';
import TextField from '../../common/textField';
import Toggle from '../../common/Toggle';
import NotifyHOC from '../../../HOC/Notifications';
import { uppercaseFirstLetter } from '@nexxt/common/services/TextService';

import CustomOptions from '../../common/reactSelect/customOptions';
import SingleValue from '../../common/reactSelect/SingleValue';
import IndicatorsContainer from '../../common/reactSelect/IndicatorsContainer';

import { botSettingsValidationSchema } from '../../common/validation/validationSchema';
import {
    BOT_SPEED,
    Panel,
    EDITABLE_UMTYPES,
    PanelType
} from '@nexxt/common/types';
import { MediaSelectType } from '../../libraries/mediaLibrary/MediaLibraryList';
import * as Action from '../../../actions/project.actions';
import { IApplicationState } from '../../../reducers';
import { Project, ProjectInfo } from '@nexxt/common/types';
import { alertMessage } from '../../../constants/alertMessage';
import { BOT_THEME_LIST } from '@nexxt/common/constants';
import { PROJECT_EDIT_MODES } from '../../../interface/project.interface';
import { DISABLED_EDIT_MODES, LOCK_PROJECT } from '../../../constants/project';
import ReactTooltip from 'react-tooltip';
import { HELPER_TOOLTIP_MAPPING } from '../../../mapping/helperTooltip';
import { SurveyLink } from '../../common/LinkGenerator';
import axios from 'axios';
import * as Cookies from 'js-cookie';
import config from '../../../config';
import BotAvatar from './BotAvatar';
import {
    getDataExportURLString,
    getExcludedSystemURLString,
    getProjectExportSettings
} from '@nexxt/common/utils/project';

const fileDownload = require('js-file-download');

interface IBotSettingsFormProps {
    handleSubmit: () => void;
    updateProjectInfo: (key: string, newValue: any) => void;
    projectInfo: ProjectInfo;
    isRequesting: boolean;
    botSettings: any; // TODOv2 change type
    notify: (
        msg: string,
        type: string,
        options?: Record<string, unknown>,
        callback?: () => unknown
    ) => any;
    type: MediaSelectType;
    editEnabled: boolean;
    editMode: PROJECT_EDIT_MODES;
    previewLink: string;
    errorObject: any;
}

interface IBotSettingsFormState {
    templateSettings: any[];
    selectedPanel: Panel;
    loading: boolean;
}
class BotSettingsForm extends React.Component<
    IBotSettingsFormProps,
    IBotSettingsFormState
> {
    constructor(props) {
        super(props);
        this.state = {
            templateSettings: null,
            selectedPanel: null,
            loading: false
        };
    }
    componentDidMount() {
        this.getTemplateSettings();
    }

    getTemplateSettings = () => {
        const { editMode, projectInfo } = this.props;
        try {
            const templateSettings =
                LOCK_PROJECT[editMode as PROJECT_EDIT_MODES][
                    projectInfo?.templateCode
                ]?.preview;

            this.setState({ templateSettings });
        } catch (err) {}
    };

    setSelectedMedia = (newMedia) => {
        this.props.updateProjectInfo('avatarImage', newMedia.src);
    };
    setPanel = ({ label, value }) => {
        const { panelSettings } = this.props.projectInfo;
        const { panels } = panelSettings;

        this.setState({ selectedPanel: panels[value] });
    };

    disableByFieldName = (fieldName = ''): boolean => {
        const { editEnabled } = this.props;
        const { templateSettings } = this.state;

        if (!editEnabled) {
            const lockMode = templateSettings || ['all'];
            return !lockMode.includes(fieldName);
        }

        return false;
    };
    onClickPreviewDownload = async (e) => {
        e.preventDefault();
        try {
            this.setState({ loading: true });
            const cssToken = Cookies.get('csst');

            const DATA_API = config.api.endpoints.downloadPreviewData;

            const res = await getProjectExportSettings(
                cssToken,
                config.host.data,
                this.props.projectInfo.id
            );
            const queryParams = getDataExportURLString(res?.dataExportSettings);

            let previewApiUrl = `${DATA_API}${
                this.props.projectInfo.id + '_PREVIEW'
            }/getTestModeData?${queryParams}&csv=true&showall=true`;

            const excludedSystemOptionsURL = getExcludedSystemURLString(
                res?.excludedSystemOptions
            );
            previewApiUrl += excludedSystemOptionsURL;

            const response = await axios.get(previewApiUrl, {
                headers: { Authorization: `Bearer ${cssToken}` },
                withCredentials: true
            });
            const exportedFileName = `${
                this.props.projectInfo.id + '_PREVIEW'
            } Preview Data.csv`;
            fileDownload(response?.data, exportedFileName);
        } catch (error) {
            console.log('ERROR: ', error);
            // handle error...
            alert('Error');
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { errorObject } = this.props;

        const {
            avatarImage,
            pageTitle,
            showProgress,
            botTheme,
            botSpeed,
            sessionTimeout,
            panelSettings
        } = this.props.projectInfo;
        const { templateSettings, selectedPanel } = this.state;
        const botThemeSelection = BOT_THEME_LIST.find(
            (theme) => theme.value === botTheme
        );
        const botSpeedLabel = uppercaseFirstLetter(botSpeed);
        const botSpeedSelection = { value: botSpeed, label: botSpeedLabel };

        const botThemeDisabled = true;
        const showProgressDisabled = true;
        const useIncaPanel = panelSettings?.panelType === PanelType.INCA;
        let previewLink = this.props.previewLink,
            previewPanelOptions = [];

        if (useIncaPanel) {
            const qmarkOrAmpersand = previewLink.includes('?') ? '&' : '?';
            previewLink = previewLink + qmarkOrAmpersand + 'TERMINATE=msg';
        } else {
            previewPanelOptions = panelSettings?.panels?.map((p, i) => ({
                label: p.name || '(no name)',
                value: i
            }));

            if (selectedPanel) {
                if (selectedPanel?.name !== 'General') {
                    const qmarkOrAmpersand = previewLink.includes('?')
                        ? '&'
                        : '?';
                    previewLink =
                        previewLink +
                        qmarkOrAmpersand +
                        `src=${selectedPanel.key || 'PANEL_NAME'}`;
                }

                if (selectedPanel.identifierKeys.length) {
                    const trackerParams = selectedPanel.identifierKeys
                        ?.map(
                            (identifier) =>
                                `${
                                    identifier?.redirectIdentifierParamKey ||
                                    identifier.identifierParamKey
                                }={unique_id}`
                        )
                        .join('&');
                    const qmarkOrAmpersand = previewLink.includes('?')
                        ? '&'
                        : '?';
                    previewLink =
                        previewLink + qmarkOrAmpersand + trackerParams;
                }
            }
        }

        return (
            <React.Fragment>
                <Formik
                    initialValues={{
                        pageTitle,
                        sessionTimeout
                    }}
                    validationSchema={botSettingsValidationSchema}
                    onSubmit={(values, actions) => {
                        // this.props.handleSubmit(actions);
                    }}
                    render={({
                        values,
                        touched,
                        handleChange,
                        handleBlur,
                        errors,
                        dirty,
                        isSubmitting
                    }) => {
                        return (
                            <Form>
                                <Prompt
                                    when={dirty}
                                    message={alertMessage.UNDO_CURRENT_CHANGE}
                                />

                                <div className="col-md-12 form-group form-group--inline-block">
                                    <label className="form-group__label form-group__label--block --full">
                                        <span>Preview Link</span>
                                        <a
                                            href={previewLink}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Open in a New Tab
                                        </a>
                                    </label>

                                    <SurveyLink
                                        onCopy={() => {}}
                                        chatbotURL={previewLink}
                                        testMode={false}
                                    />
                                    {previewPanelOptions?.length ? (
                                        <div>
                                            Preview link as{' '}
                                            <Select
                                                options={previewPanelOptions}
                                                onChange={(value) =>
                                                    this.setPanel(value)
                                                }
                                            />
                                        </div>
                                    ) : null}
                                    <div>
                                        <button
                                            className="btn btn--sm btn--blue mt-2"
                                            type="button"
                                            onClick={
                                                this.onClickPreviewDownload
                                            }
                                            disabled={this.state.loading}
                                        >
                                            {this.state.loading
                                                ? 'Loading...'
                                                : 'Download Preview Data'}
                                        </button>
                                    </div>
                                </div>
                                <div className="col-md-12 form-group">
                                    <BotAvatar
                                        showTitle
                                        setSelectedMedia={this.setSelectedMedia}
                                        avatarImage={avatarImage}
                                        disabled={this.disableByFieldName()}
                                    />
                                </div>
                                <TextField
                                    type="text"
                                    name="pageTitle"
                                    disabled={this.disableByFieldName()}
                                    value={pageTitle}
                                    onChange={(event) =>
                                        this.props.updateProjectInfo(
                                            'pageTitle',
                                            event.target.value
                                        )
                                    }
                                    onBlur={handleBlur}
                                    placeholder="Page Title"
                                    label="Page Title"
                                    errorMessage={errors.pageTitle}
                                    touchedValue={touched.pageTitle}
                                    col={
                                        errorObject?.pageTitle ||
                                        (errors.pageTitle &&
                                            (touched.pageTitle || pageTitle))
                                            ? 'col-md-12 form-group form-group--inline-block error'
                                            : 'col-md-12 form-group form-group--inline-block'
                                    }
                                />

                                {!botThemeDisabled && (
                                    <div className="col-md-12 form-group form-group--inline-block">
                                        <label className="form-group__label form-group__label--block">
                                            Bot Theme
                                        </label>
                                        <Select
                                            className={
                                                'form-select--react-select react-select theme-selection'
                                            }
                                            // menuIsOpen={true}
                                            classNamePrefix="react-select"
                                            value={botThemeSelection}
                                            options={BOT_THEME_LIST}
                                            onChange={(opt) =>
                                                this.props.updateProjectInfo(
                                                    'botTheme',
                                                    opt.value
                                                )
                                            }
                                            isDisabled={this.disableByFieldName()}
                                            // placeholder="Select bot theme"
                                            col="col-md-12"
                                            components={{
                                                Option: CustomOptions,
                                                SingleValue,
                                                IndicatorsContainer
                                            }}
                                        />
                                    </div>
                                )}

                                <div className="col-md-12 form-group form-group--inline-block">
                                    <label
                                        className="form-group__label form-group__label--block"
                                        data-tip="bot speed"
                                        data-for="bot-speed"
                                    >
                                        Bot Speed
                                    </label>
                                    <ReactTooltip
                                        id="bot-speed"
                                        aria-haspopup="true"
                                        effect="solid"
                                        place="bottom"
                                        backgroundColor="#595959"
                                        className="longContent"
                                    >
                                        {HELPER_TOOLTIP_MAPPING['Bot Speed']}
                                    </ReactTooltip>
                                    <Select
                                        className={
                                            'form-select--react-select react-select'
                                        }
                                        classNamePrefix="react-select"
                                        value={botSpeedSelection}
                                        options={BOT_SPEED}
                                        onChange={(opt) =>
                                            this.props.updateProjectInfo(
                                                'botSpeed',
                                                opt.value
                                            )
                                        }
                                        isDisabled={this.disableByFieldName()}
                                        // placeholder="Seslect bot settings"
                                        col="col-md-6"
                                        components={{
                                            IndicatorsContainer
                                        }}
                                    />
                                </div>

                                {!showProgressDisabled && (
                                    <div className="col-md-12 form-group form-group--inline-block">
                                        <label
                                            className="form-group__label form-group__label--block"
                                            data-tip="show progress bar"
                                            data-for="show-progress-bar"
                                        >
                                            Show progress bar
                                        </label>
                                        <ReactTooltip
                                            id="show-progress-bar"
                                            aria-haspopup="true"
                                            effect="solid"
                                            place="bottom"
                                            backgroundColor="#595959"
                                            className="longContent"
                                        >
                                            {
                                                HELPER_TOOLTIP_MAPPING[
                                                    'Show progress bar'
                                                ]
                                            }
                                        </ReactTooltip>
                                        <Toggle
                                            onChange={(e) =>
                                                this.props.updateProjectInfo(
                                                    'showProgress',
                                                    !showProgress
                                                )
                                            }
                                            checked={showProgress}
                                            disabled={this.disableByFieldName()}
                                        />
                                    </div>
                                )}

                                <TextField
                                    type="number"
                                    min="1"
                                    max="24"
                                    onBlur={handleBlur}
                                    name="sessionTimeout"
                                    label="Session Timeout"
                                    subLabel="hours"
                                    onChange={(e) =>
                                        this.props.updateProjectInfo(
                                            'sessionTimeout',
                                            e.target.value
                                        )
                                    }
                                    disabled={this.disableByFieldName()}
                                    placeholder="Session Timeout"
                                    value={sessionTimeout}
                                    errorMessage={errors.sessionTimeout}
                                    touchedValue={touched.sessionTimeout}
                                    col={
                                        errorObject?.sessionTimeout ||
                                        (errors.sessionTimeout &&
                                            (touched.sessionTimeout ||
                                                sessionTimeout))
                                            ? 'col-md-12 form-group form-group--inline-block error'
                                            : 'col-md-12 form-group form-group--inline-block'
                                    }
                                />
                                {/* <div className="btn-wrapper">
                                    <button
                                        disabled={
                                            isSubmitting || !unlockAudience
                                        }
                                        type="submit"
                                        className="btn btn--sm btn--green"
                                    >
                                        Save
                                    </button>
                                </div> */}
                            </Form>
                        );
                    }}
                />
            </React.Fragment>
        );
    }
}

// export default NotifyHOC(BotSettingsForm);
const mapStateToProps = (store) => {
    const {
        projectReducer: { currentProject, botSettings, editEnabled, editMode },
        router: { location }
    }: IApplicationState = store;
    return {
        currentProject,
        location,
        botSettings,
        editEnabled: editEnabled['settings'],
        editMode
    };
};

const mapDispatchToProps = (dispatch) => ({
    setBotSettings: (botSettings: Project) => {
        dispatch(Action.setBotSettings(botSettings));
    },
    setProject: (botSettings: any) => {
        dispatch(Action.setProject(botSettings));
    }
});

export default NotifyHOC(
    connect(mapStateToProps, mapDispatchToProps)(BotSettingsForm)
);
